import { render, staticRenderFns } from "./BeNotificationsWidget.vue?vue&type=template&id=74b11372&scoped=true"
import script from "./BeNotificationsWidget.vue?vue&type=script&lang=js"
export * from "./BeNotificationsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b11372",
  null
  
)

export default component.exports